import React from 'react';
import { translate } from 'Shared/translate';
import classnames from 'classnames';
import * as styles from './base.scss';
export const ProductMark = (props) => (React.createElement("span", { className: classnames(props.className, styles.productMark, styles[props.layout]) }, props.text));
function isNonStockable(props) {
    return (!props.quotationOnly && !props.isCloseOut && !props.isInCampaign && !props.isStockable && !props.isDiscontinued);
}
function haveMarkings(props) {
    return props.markings && props.markings.length > 0;
}
function haveProductMark(props) {
    return haveMarkings(props) || props.isCloseOut || props.isInCampaign || isNonStockable(props) || props.isInQuotation;
}
export default (props) => haveProductMark(props) && (React.createElement("div", { className: classnames(styles.base, {
        [styles.productMarkWrapperList]: props.isRow,
        [styles.productMarkWrapper]: !props.isRow,
        [styles.inline]: props.inline,
    }) },
    haveMarkings(props) && props.markings.map(mark => React.createElement(ProductMark, Object.assign({}, mark, { className: props.className }))),
    (props.isCloseOut && !props.nonStockableOnly && (React.createElement(ProductMark, { text: translate('/Product/CloseOutCampaign'), layout: "campaign", className: props.className }))) ||
        (props.isInCampaign && !props.nonStockableOnly && (React.createElement(ProductMark, { text: translate('/Product/Campaign'), layout: "campaign", className: props.className }))),
    isNonStockable(props) && (React.createElement(ProductMark, { text: translate('/Product/NonStockable'), layout: "primary", className: props.className })),
    props.isInQuotation && !props.nonStockableOnly && (React.createElement(ProductMark, { text: translate('/Product/Quotation'), layout: "secondary", className: props.className }))));
